var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2032_7797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6729 7.41166L17.9854 14.8811C18.8141 16.3166 18.3227 18.1505 16.8873 18.9792C15.4519 19.808 13.618 19.3166 12.7892 17.8811L8.10172 9.76214C7.85308 9.33148 7.7857 8.81969 7.91441 8.33935C8.04311 7.85902 8.35736 7.44948 8.78802 7.20084C9.21868 6.9522 9.73047 6.88482 10.2108 7.01353C10.6911 7.14223 11.1007 7.45648 11.3493 7.88714L15.2868 14.7071C15.4931 15.0643 15.3695 15.5254 15.0123 15.7316C14.6551 15.9379 14.194 15.8143 13.9878 15.4571L10.4253 9.28666L9.451 9.84916L13.0135 16.0196C13.2621 16.4502 13.6717 16.7645 14.152 16.8932C14.6323 17.0219 15.1441 16.9545 15.5748 16.7059C16.0055 16.4572 16.3197 16.0477 16.4484 15.5674C16.5771 15.087 16.5097 14.5752 16.2611 14.1446L12.3236 7.32464C11.4948 5.8892 9.66095 5.39781 8.22552 6.22656C6.79008 7.05531 6.29869 8.8892 7.12744 10.3246L11.8149 18.4436C12.9549 20.4182 15.4753 21.0935 17.4498 19.9535C19.4243 18.8135 20.0997 16.2932 18.9597 14.3186L14.6472 6.84916L13.6729 7.41166Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2032_7797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.705811 9.70312) rotate(-30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.28472b686c1a103cb5b0a55df8ce0049.svg";
export { ForwardRef as ReactComponent };